import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=f004c7c6&scoped=true&"
import script from "./PageLoader.vue?vue&type=script&lang=ts&"
export * from "./PageLoader.vue?vue&type=script&lang=ts&"
import style0 from "./PageLoader.vue?vue&type=style&index=0&id=f004c7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f004c7c6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VFadeTransition,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f004c7c6')) {
      api.createRecord('f004c7c6', component.options)
    } else {
      api.reload('f004c7c6', component.options)
    }
    module.hot.accept("./PageLoader.vue?vue&type=template&id=f004c7c6&scoped=true&", function () {
      api.rerender('f004c7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/PageLoader.vue"
export default component.exports